import { render, staticRenderFns } from "./AppAttendanceLayout.vue?vue&type=template&id=c96be82c&scoped=true"
import script from "./AppAttendanceLayout.vue?vue&type=script&lang=js"
export * from "./AppAttendanceLayout.vue?vue&type=script&lang=js"
import style0 from "./AppAttendanceLayout.vue?vue&type=style&index=0&id=c96be82c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96be82c",
  null
  
)

export default component.exports